export default __webpack_public_path__ + "static/media/rounded-back.7ff32a68.webp";